const preloadImage = (src, callback) => {
  if (!src) {
    return
  }

  if (src.includes('giant_thumb')) {
    src = src.replace('giant_thumb_', '')
  }

  const img = new Image()
  img.src = src
  if (typeof callback === 'function') {
    img.onload = callback
  }
}

const preloadFromObject = (object, size, callback) => {
  if (!object) {
    return
  }

  const src = object.sizes[size]
  preloadImage(src, callback)
}

export { preloadImage, preloadFromObject }
